import { getUID } from '../../../../utility/key-generator';
import { WebClient } from '../../../../webclient/webclient.service';
import * as $ from 'jquery';
import { convertTiff, convert } from './image-converter';


export class FileListInputData {

    private files = [];

    constructor(private inputHtml, public name, private attributes) {
    }

    public static isImage(file) {
        return file.type.toString().indexOf('image') > -1;
    }


    private getError(file) {
        let error = { min: false, max: false, accepted: false };
        if (this.attributes['data-min-size']) {
            let min = this.attributes['data-min-size'].value * 1024 * 1024;
            if (min && file.size <= min) {
                error.min = true;
            }
        }
        if (this.attributes['data-max-size']) {
            let max = this.attributes['data-max-size'].value * 1024 * 1024;
            if (max && file.size >= max) {
                error.max = true;
            }
        }
        if (this.attributes['data-accept']) {
            let allowedFiles = this.attributes['data-accept'].value.split('|');
            for ( let index in allowedFiles ) {
                allowedFiles[index] = '.' + allowedFiles[index];
            }
            let regex = new RegExp("([a-zA-Z0-9\s_\\.\-:])+(" + allowedFiles.join('|') + ")$");
            if (!regex.test(file.name.toLowerCase())) {
                error.accepted = true;
            }
        }
        return error;
    }


    public getInput() {
        return $(this.inputHtml);
    }

    public addFiles(files: FileList, busyFn: Function) {
        const isImageUploader = this.attributes['data-cropper'].value == 'true';
        for (var i = 0; i < files.length; i++) {
            let file = files.item(i);
            (file as any).uid = getUID();
            (file as any).error = this.getError(file);
            this.files.push(file);
            if (isImageUploader) {
                this.getBase64Image((file as any).uid, busyFn);
            }
        }
    }

    public addCopyrightInfo(info: string, uid: string) {
        let file = this.getFileByUID(uid);
        if (file) {
            file.copyrightInfo = info;
        }
    }

    public setBase64Image(uid, img) {
        let file = this.getFileByUID(uid);
        if (file) {
            file.base64Image = img;
        }
    }

    private isTiff(file) {
        return file.type.toString().indexOf('tif') > 0;
    }

    private uploadImage(file, busyFn) {

        WebClient.saveCroppedImage(this.getFileName(file.uid), null, file.base64Image).then(result => {
            if (result.success)
                file.serverName = result.newImagePath;
            file.busy = false;
            busyFn(file);
        })

    }

    public getFileName(uid) {
        const file = this.getFileByUID(uid);
        if (file) {
            return file.convertedName ? file.convertedName : file.name
        }
        return '';

    }

    private changeExtension(file: File, ext: string) {
        try {
            let tmp = file.name.split('.');
            tmp.pop();
            tmp.push(ext);
            (file as any).convertedName = tmp.join('.');
        }
        catch (ex) { }
    }



    public getBase64Image(uid, busyFn) {
        const promise = new Promise((resolve, reject) => {
            let file = this.getFileByUID(uid);
            if (!file) {
                reject('Error finding file');
                console.warn('Error finding file');
                return;
            }
            if (file.base64Image) {
                resolve(file.base64Image);
                return;
            }
            file.busy = true;
            busyFn(file);
            if (this.isTiff(file)) {
                convertTiff(file)
                    .then(b64 => {
                        file.base64Image = b64;
                        this.changeExtension(file, 'png');
                        this.uploadImage(file, busyFn);
                    })
                    .catch(() => {
                        file.busy = false;
                        busyFn()
                    })
            }
            else {
                convert(file)
                    .then(b64 => {
                        file.base64Image = b64;
                        this.uploadImage(file, busyFn);
                    })
                    .catch(() => {
                        file.busy = false;
                        busyFn()
                    })
            }
        })
        return promise;
    }



    public getFileByUID(uid) {
        let file = this.files.filter(f => f.uid === uid);
        if (file.length) return file[0];
        return null;
    }

    public getFileType(uid) {
        const file = this.getFileByUID(uid);
        if (file) {
            return file.type;
        }
    }

    public deleteFile(uid) {
        let file = this.getFileByUID(uid);
        if (file) {
            this.files.splice(this.files.indexOf(file), 1);
        }
    }

    public resetFiles() {
        this.files = [];
    }

    public getFiles() {
        return this.files;
    }

    public addFilesToFormData(formData) {
        for (let i = 0; i < this.files.length; i++)
            formData.append(this.name, this.files[i]);
        return this.files.length > 0;
    }


}